module.exports = __webpack_public_path__ + "img/playMind.30f788ee.svg";